export default {
  newDesign: true,
  title: "¿Estás en la misma onda que tu hijo? | Kodland",
  parameters: {
    landing_id: "EsQuUnPaid",
    segment: 14,
  },
  downtimeUrl: "http://kodland.org/es",
  startPage: {
    title:
      "¡Haz este test en solo 1 minuto y descubre si entiendes los memes y el slang de tu hijo!",
    subtitle:
      "✅ Creado con la ayuda de adolescentes reales<br>👨‍👩‍👧‍👦 Más de 100,000 familias ya lo han probado<br>🎁 Incluye un regalo especial al finalizar",
    image: {
      url: "/welcome/es_content_understanding_paid_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/es_content_understanding_paid_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " ¡Empezar el test! 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Cuál de estos es un meme popular en TikTok?",
      answers: ["lalala lama 🦙", "wiwiwi wiwi 😅", "rrr parrot 🦜"],
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid1.png",
      subtitle:
        "En TikTok, hay un gatito que se ha vuelto viral porque dice algo parecido a «wiwiwi». ¡Quizá puedas intentarlo para llamar a tu hijo/a a cenar!",
      button: "¡Wiwiwi!",
    },
    3: {
      question: "¿Sabes de dónde es este personaje?",
      image: {
        answeWithImage: true,
        image_main: "/welcome/paid2.png",
        imageMobile: "",
        isMainImage: true,
        isVideo: false,
      },
      answers: [
        "¿De algún dibujo animado?...",
        "¡Claro, de Lego!",
        "¡Claro, de Minecraft!",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid3.png",
      subtitle:
        "Mientras algunos videojuegos buscan gráficos ultra realistas, los adolescentes siguen amando Minecraft, ¡un mundo entero hecho de bloques!",
      button: "¡Debería probarlo!",
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid4_es.png",
      subtitle:
        "Por cierto, en Kodland tenemos cursos online de desarrollo de videojuegos. Si tu hijo/a pasa horas en el mundo gamer, ¡quizás le encante aprender a crear sus propios juegos! Completa el test y obtén un regalo especial para probarlo 🎁",
      button: "Continuar",
    },
    6: {
      question: "¿Tu hijo/a podría ser CEO de algo?",
      answers: ["Tal vez cuando crezca…", "Sí, ¡es el CEO del desorden!"],
    },
    7: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid5.png",
      subtitle:
        "En el mundo adolescente, puedes ser CEO sin trabajar en una empresa. Decir «ser CEO de algo» solo significa ser muy bueno/a en eso.",
      button: "¡Seré CEO del slang!",
    },
    8: {
      question: "Si tu hijo/a te dice que estás «delulu», ¿deberías ofenderte?",
      answers: [
        "¡Qué palabra tan simpática! Creo que no",
        "¡Delulu lo será él/ella!",
      ],
    },
    9: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid6.png",
      subtitle:
        "«Delulu» viene de «delusional», y se usa para describir a alguien que está un poco desconectado de la realidad.",
      button: "¡Ok!",
    },
    10: {
      question: "¿Tu hijo/a te cuenta sus cosas personales o problemas?",
      answers: [
        "Sí, hablamos de todo",
        "No, soy su papá/mamá, no su amigo/a",
        "Me gustaría, pero no suele hacerlo",
      ],
    },
    11: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid7_es.png",
      subtitle:
        "La conexión emocional con tu hijo/a es clave, pero recuerda que es normal que con el tiempo busque más independencia. Separarse no significa alejarse.",
      button: "Seré paciente",
    },
    12: {
      question:
        "¿Tienes una computadora de escritorio o portátil con la que tu hijo puedo estudiar?",
      answers: [
        "👍 Sí",
        {
          answer: "👎 No",
          stopAnswer: true,
        },
      ],
    },
    13: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      subtitle:
        "Elegiremos el curso más entretenido según la edad de tu hijo/a",
      button: "",
    },
    14: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid8_es.png",
      title: "¡Esperamos que este test te haya sido útil!",
      subtitle:
        "🎁 No olvides tu regalo: una clase gratuita de programación en línea para tu hijo/a con un profesor profesional en Kodland.",
      button: "Reservar clase gratuita",
    },
    15: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    16: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    17: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    18: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    19: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
